import baseRequest from "../_core/baseRequest";

export default {
    /* groupName'in tanımlı olduğu optionları listeler */
    getOptionsByGroupName: ({groupName}) =>
        baseRequest.get(`form-options/pretty/${groupName || ""}`),
    /* belirtilen filtrelere uygun olan kayıtları getirir */
    getOptions: params => baseRequest.post(`form-options/pretty`, params),
    // City Operations
    getCityList: params => {
        const queryParams = new URLSearchParams();
        if (params?.sort) queryParams.append("sort", params.sort);
        if (params?.limit) queryParams.append("limit", params.limit);
        if (params?.skip) queryParams.append("skip", params.skip);

        return baseRequest.get(`/options/cities?${queryParams.toString()}`);
    },

    getCityById: params => {
        return baseRequest.get(`/options/cities/${params.id}`);
    },

    // District Operations
    getDistrictList: params => {
        const queryParams = new URLSearchParams();
        if (params?.cityId) queryParams.append("cityId", params.cityId);
        if (params?.cityName) queryParams.append("cityName", params.cityName);
        if (params?.sort) queryParams.append("sort", params.sort);
        if (params?.limit) queryParams.append("limit", params.limit);
        if (params?.skip) queryParams.append("skip", params.skip);

        return baseRequest.get(`/options/districts?${queryParams.toString()}`);
    },

    getDistrictById: params => {
        return baseRequest.get(`/options/districts/${params.id}`);
    },

    // Neighborhood Operations
    getNeighborhoodList: params => {
        const queryParams = new URLSearchParams();
        if (params?.districtId) queryParams.append("districtId", params.districtId);
        if (params?.sort) queryParams.append("sort", params.sort);
        if (params?.limit) queryParams.append("limit", params.limit);
        if (params?.skip) queryParams.append("skip", params.skip);

        return baseRequest.get(`/options/neighborhoods?${queryParams.toString()}`);
    },

    getNeighborhoodById: params => {
        return baseRequest.get(`/options/neighborhoods/${params.id}`);
    }
};
